const ITEMS = [
  "9+ Years Recruitment Expertise",
  "IT & Non-IT Hiring",
  "PAN India Coverage",
  "MNC & Fortune 500 Client Experience",
  "Leadership Hiring",
  "Volume Hiring",
  "End-to-End Recruitment",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/[0.06] bg-[#060B18] py-5">
      <div className="animate-marquee flex w-max items-center gap-12">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-12 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.28em] text-slate-500">
            {t}
            <span className="h-1 w-1 rounded-full bg-cyan-400 shadow-[0_0_10px_rgba(6,182,212,0.9)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
